import axios from "axios";

const API_BASE = process.env.REACT_APP_API_BASE_URL;

export const estimatedChargesApi = {
  calculateStopEstimatedCharges: async ({
    token,
    officeCode,
    shipmentNumber,
    stopId,
    stopType,
    actualGateIn,
    actualGateOut,
    appointmentStartTime,
    appointmentEndTime,
  }) => {
    return axios.put(
      `${API_BASE}/api/estimated-charges/calculate`,
      {
        shipmentNumber,
        stopId,
        stopType,
        actualGateIn,
        actualGateOut,
        appointmentStartTime,
        appointmentEndTime,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Office-Code": officeCode,
          "Content-Type": "application/json",
        },
      }
    );
  },
};
